import React from "react";
import { FaJava } from "react-icons/fa";
import { IoLogoJavascript } from "react-icons/io";
import { BiLogoSpringBoot } from "react-icons/bi";
import { RiReactjsFill } from "react-icons/ri";
import { FaAws } from "react-icons/fa";
import code1 from "../images/code1.png";
import code2 from "../images/code2.jpeg";
import code3 from "../images/code3.jpeg";
const About = () => {
  return (
    <div
      name="about"
      className="w-full bg-gradient-to-b from-gray-800 to-black "
    >
      <div className="max-w-screen-lg mx-auto p-4 pt-10 flex flex-col justify-center w-full h-full text-white">
        <div>
          <div class="container mx-auto">
            <div class="flex flex-wrap items-center justify-between -mx-4">
              <div class="w-full px-4 lg:w-6/12 order-2 lg:order-1">
                <div class="flex items-center -mx-3 sm:-mx-4">
                  <div class="w-full px-3 sm:px-4 xl:w-1/2">
                    <div class="py-3 sm:py-4">
                      <img src={code1} alt="" class="w-full rounded-2xl" />
                    </div>
                    <div class="py-3 sm:py-4">
                      <img src={code3} alt="" class="w-full rounded-2xl" />
                    </div>
                  </div>
                  <div class="w-full px-3 sm:px-4 xl:w-1/2">
                    <div class="relative z-10 my-4">
                      <img src={code2} alt="" class="w-full rounded-2xl" />
                      <span class="absolute -right-4 -bottom-10 z-[-1]">
                        <svg
                          width="134"
                          height="106"
                          viewBox="0 0 134 106"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="1.66667"
                            cy="104"
                            r="1.66667"
                            transform="rotate(-90 1.66667 104)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="16.3333"
                            cy="104"
                            r="1.66667"
                            transform="rotate(-90 16.3333 104)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="31"
                            cy="104"
                            r="1.66667"
                            transform="rotate(-90 31 104)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="45.6667"
                            cy="104"
                            r="1.66667"
                            transform="rotate(-90 45.6667 104)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="60.3334"
                            cy="104"
                            r="1.66667"
                            transform="rotate(-90 60.3334 104)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="88.6667"
                            cy="104"
                            r="1.66667"
                            transform="rotate(-90 88.6667 104)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="117.667"
                            cy="104"
                            r="1.66667"
                            transform="rotate(-90 117.667 104)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="74.6667"
                            cy="104"
                            r="1.66667"
                            transform="rotate(-90 74.6667 104)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="103"
                            cy="104"
                            r="1.66667"
                            transform="rotate(-90 103 104)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="132"
                            cy="104"
                            r="1.66667"
                            transform="rotate(-90 132 104)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="1.66667"
                            cy="89.3333"
                            r="1.66667"
                            transform="rotate(-90 1.66667 89.3333)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="16.3333"
                            cy="89.3333"
                            r="1.66667"
                            transform="rotate(-90 16.3333 89.3333)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="31"
                            cy="89.3333"
                            r="1.66667"
                            transform="rotate(-90 31 89.3333)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="45.6667"
                            cy="89.3333"
                            r="1.66667"
                            transform="rotate(-90 45.6667 89.3333)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="60.3333"
                            cy="89.3338"
                            r="1.66667"
                            transform="rotate(-90 60.3333 89.3338)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="88.6667"
                            cy="89.3338"
                            r="1.66667"
                            transform="rotate(-90 88.6667 89.3338)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="117.667"
                            cy="89.3338"
                            r="1.66667"
                            transform="rotate(-90 117.667 89.3338)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="74.6667"
                            cy="89.3338"
                            r="1.66667"
                            transform="rotate(-90 74.6667 89.3338)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="103"
                            cy="89.3338"
                            r="1.66667"
                            transform="rotate(-90 103 89.3338)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="132"
                            cy="89.3338"
                            r="1.66667"
                            transform="rotate(-90 132 89.3338)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="1.66667"
                            cy="74.6673"
                            r="1.66667"
                            transform="rotate(-90 1.66667 74.6673)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="1.66667"
                            cy="31.0003"
                            r="1.66667"
                            transform="rotate(-90 1.66667 31.0003)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="16.3333"
                            cy="74.6668"
                            r="1.66667"
                            transform="rotate(-90 16.3333 74.6668)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="16.3333"
                            cy="31.0003"
                            r="1.66667"
                            transform="rotate(-90 16.3333 31.0003)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="31"
                            cy="74.6668"
                            r="1.66667"
                            transform="rotate(-90 31 74.6668)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="31"
                            cy="31.0003"
                            r="1.66667"
                            transform="rotate(-90 31 31.0003)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="45.6667"
                            cy="74.6668"
                            r="1.66667"
                            transform="rotate(-90 45.6667 74.6668)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="45.6667"
                            cy="31.0003"
                            r="1.66667"
                            transform="rotate(-90 45.6667 31.0003)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="60.3333"
                            cy="74.6668"
                            r="1.66667"
                            transform="rotate(-90 60.3333 74.6668)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="60.3333"
                            cy="30.9998"
                            r="1.66667"
                            transform="rotate(-90 60.3333 30.9998)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="88.6667"
                            cy="74.6668"
                            r="1.66667"
                            transform="rotate(-90 88.6667 74.6668)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="88.6667"
                            cy="30.9998"
                            r="1.66667"
                            transform="rotate(-90 88.6667 30.9998)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="117.667"
                            cy="74.6668"
                            r="1.66667"
                            transform="rotate(-90 117.667 74.6668)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="117.667"
                            cy="30.9998"
                            r="1.66667"
                            transform="rotate(-90 117.667 30.9998)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="74.6667"
                            cy="74.6668"
                            r="1.66667"
                            transform="rotate(-90 74.6667 74.6668)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="74.6667"
                            cy="30.9998"
                            r="1.66667"
                            transform="rotate(-90 74.6667 30.9998)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="103"
                            cy="74.6668"
                            r="1.66667"
                            transform="rotate(-90 103 74.6668)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="103"
                            cy="30.9998"
                            r="1.66667"
                            transform="rotate(-90 103 30.9998)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="132"
                            cy="74.6668"
                            r="1.66667"
                            transform="rotate(-90 132 74.6668)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="132"
                            cy="30.9998"
                            r="1.66667"
                            transform="rotate(-90 132 30.9998)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="1.66667"
                            cy="60.0003"
                            r="1.66667"
                            transform="rotate(-90 1.66667 60.0003)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="1.66667"
                            cy="16.3333"
                            r="1.66667"
                            transform="rotate(-90 1.66667 16.3333)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="16.3333"
                            cy="60.0003"
                            r="1.66667"
                            transform="rotate(-90 16.3333 60.0003)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="16.3333"
                            cy="16.3333"
                            r="1.66667"
                            transform="rotate(-90 16.3333 16.3333)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="31"
                            cy="60.0003"
                            r="1.66667"
                            transform="rotate(-90 31 60.0003)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="31"
                            cy="16.3333"
                            r="1.66667"
                            transform="rotate(-90 31 16.3333)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="45.6667"
                            cy="60.0003"
                            r="1.66667"
                            transform="rotate(-90 45.6667 60.0003)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="45.6667"
                            cy="16.3333"
                            r="1.66667"
                            transform="rotate(-90 45.6667 16.3333)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="60.3333"
                            cy="60.0003"
                            r="1.66667"
                            transform="rotate(-90 60.3333 60.0003)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="60.3333"
                            cy="16.3333"
                            r="1.66667"
                            transform="rotate(-90 60.3333 16.3333)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="88.6667"
                            cy="60.0003"
                            r="1.66667"
                            transform="rotate(-90 88.6667 60.0003)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="88.6667"
                            cy="16.3333"
                            r="1.66667"
                            transform="rotate(-90 88.6667 16.3333)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="117.667"
                            cy="60.0003"
                            r="1.66667"
                            transform="rotate(-90 117.667 60.0003)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="117.667"
                            cy="16.3333"
                            r="1.66667"
                            transform="rotate(-90 117.667 16.3333)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="74.6667"
                            cy="60.0003"
                            r="1.66667"
                            transform="rotate(-90 74.6667 60.0003)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="74.6667"
                            cy="16.3333"
                            r="1.66667"
                            transform="rotate(-90 74.6667 16.3333)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="103"
                            cy="60.0003"
                            r="1.66667"
                            transform="rotate(-90 103 60.0003)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="103"
                            cy="16.3333"
                            r="1.66667"
                            transform="rotate(-90 103 16.3333)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="132"
                            cy="60.0003"
                            r="1.66667"
                            transform="rotate(-90 132 60.0003)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="132"
                            cy="16.3333"
                            r="1.66667"
                            transform="rotate(-90 132 16.3333)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="1.66667"
                            cy="45.3333"
                            r="1.66667"
                            transform="rotate(-90 1.66667 45.3333)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="1.66667"
                            cy="1.66683"
                            r="1.66667"
                            transform="rotate(-90 1.66667 1.66683)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="16.3333"
                            cy="45.3333"
                            r="1.66667"
                            transform="rotate(-90 16.3333 45.3333)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="16.3333"
                            cy="1.66683"
                            r="1.66667"
                            transform="rotate(-90 16.3333 1.66683)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="31"
                            cy="45.3333"
                            r="1.66667"
                            transform="rotate(-90 31 45.3333)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="31"
                            cy="1.66683"
                            r="1.66667"
                            transform="rotate(-90 31 1.66683)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="45.6667"
                            cy="45.3333"
                            r="1.66667"
                            transform="rotate(-90 45.6667 45.3333)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="45.6667"
                            cy="1.66683"
                            r="1.66667"
                            transform="rotate(-90 45.6667 1.66683)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="60.3333"
                            cy="45.3338"
                            r="1.66667"
                            transform="rotate(-90 60.3333 45.3338)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="60.3333"
                            cy="1.66683"
                            r="1.66667"
                            transform="rotate(-90 60.3333 1.66683)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="88.6667"
                            cy="45.3338"
                            r="1.66667"
                            transform="rotate(-90 88.6667 45.3338)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="88.6667"
                            cy="1.66683"
                            r="1.66667"
                            transform="rotate(-90 88.6667 1.66683)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="117.667"
                            cy="45.3338"
                            r="1.66667"
                            transform="rotate(-90 117.667 45.3338)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="117.667"
                            cy="1.66683"
                            r="1.66667"
                            transform="rotate(-90 117.667 1.66683)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="74.6667"
                            cy="45.3338"
                            r="1.66667"
                            transform="rotate(-90 74.6667 45.3338)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="74.6667"
                            cy="1.66683"
                            r="1.66667"
                            transform="rotate(-90 74.6667 1.66683)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="103"
                            cy="45.3338"
                            r="1.66667"
                            transform="rotate(-90 103 45.3338)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="103"
                            cy="1.66683"
                            r="1.66667"
                            transform="rotate(-90 103 1.66683)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="132"
                            cy="45.3338"
                            r="1.66667"
                            transform="rotate(-90 132 45.3338)"
                            fill="#3056D3"
                          />
                          <circle
                            cx="132"
                            cy="1.66683"
                            r="1.66667"
                            transform="rotate(-90 132 1.66683)"
                            fill="#3056D3"
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-full px-4 lg:w-1/2 xl:w-5/12 order-1 lg:order-2">
                <div class="mt-10 lg:mt-0">
                  <span class="block mb-4 text-lg font-semibold text-primary">
                    About Me
                  </span>
                  <h2 class="mb-5 text-3xl font-bold text-dark dark:text-white sm:text-[40px]/[48px]">
                    Empowering Innovation Through Code
                  </h2>
                  <p class="mb-5 text-base text-body-color dark:text-dark-6">
                    As a Full Stack Developer with 2.5 years of experience. I
                    excel in building end-to-end solutions that seamlessly
                    integrate front-end and back-end functionalities. Let's
                    collaborate and bring your projects to life with expertise
                    and precision!
                  </p>
                  <p className="text-sm text-neutral-400 pb-1">
                    Core Technologies
                  </p>
                  <div className="grid grid-cols-5 gap-3">
                    <div className="bg-[#333333]/40 p-3 md:p-5 rounded-lg flex flex-col items-center">
                      <span className="text-red-600">
                        <FaJava />
                      </span>
                    </div>
                    <div className="bg-[#333333]/40 p-3 md:p-5 rounded-lg flex flex-col items-center">
                      <span className="text-green-500">
                        <BiLogoSpringBoot />
                      </span>
                    </div>
                    <div className="bg-[#333333]/40 p-3 md:p-5 rounded-lg flex flex-col items-center">
                      <span className="text-yellow-600">
                        <IoLogoJavascript />
                      </span>
                    </div>
                    <div className="bg-[#333333]/40 p-3 md:p-5 rounded-lg flex flex-col items-center">
                      <span className="text-cyan-500">
                        <RiReactjsFill />
                      </span>
                    </div>
                    <div className="bg-[#333333]/40 p-3 md:p-5 rounded-lg flex flex-col items-center">
                      <span className="text-orange-500">
                        <FaAws />
                      </span>
                    </div>
                  </div>

                  {/* <div className="grid grid-cols-3 gap-3 md:ml-8 py-4 px-0 ">
                      <div className="bg-[#333333]/40 p-3 md:p-5 rounded-lg flex flex-col items-center">
                        <h3 className="text-sm text-white">2+ years</h3>
                        <p className="md:text-base text-md text-white font-bold">
                          Experience
                        </p>
                      </div>
                      <div className="bg-[#333333]/40 p-3 md:p-5 rounded-lg flex flex-col items-center">
                        <h3 className="text-sm text-white">2</h3>
                        <p className="md:text-base text-md text-white font-bold">
                          Certifications Earned
                        </p>
                      </div>
                      <div className="bg-[#333333]/40 p-3 md:p-5 rounded-lg flex flex-col items-center">
                        <h3 className="text-sm text-white">2+ years</h3>
                        <p className="md:text-base text-md text-white font-bold">
                          Experience
                        </p>
                      </div>{" "}
                    </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container relative flex flex-col justify-between max-w-6xl xl:px-0 mt-10">
          <div class="w-full">
            <div class="flex flex-col w-full mb-10 sm:flex-row">
              <div class="w-full mb-10 sm:mb-0 sm:w-1/2">
                <div className="">
                  <h2 className="text-3xl sm:text-3xl lg:text-5xl mt-6 leading-tight font-handwriting">
                    What we do for you
                  </h2>
                  <p className="text-neutral-500 text-sm">
                    With 3 years of diverse experience across multiple
                    technologies, we specialize in full-stack development and
                    efficient DevOps operations. Let us pave the way for your
                    digital triumph.
                  </p>
                </div>
              </div>
              <div class="w-full sm:w-1/2">
                <div class="relative h-full ml-0 ">
                  <span class="absolute top-0 left-0 w-full h-full mt-1 ml-1 bg-purple-500 rounded-lg"></span>
                  <div class="relative h-full p-5 bg-white border-2 border-purple-500 rounded-lg">
                    <div class="flex items-center -mt-1">
                      <h3 class="my-2 ml-3 text-lg font-bold text-gray-800">
                        Backend Servcies
                        <p class=" text-xs font-medium text-purple-500 uppercase">
                          ------------
                        </p>
                      </h3>
                    </div>
                    <p class="mb-2 text-gray-600">
                      With a core focus on backend expertise, we create robust
                      and scalable microservices using Java and Spring Boot,
                      ensuring seamless performance and scalability.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="flex flex-col w-full mb-5 sm:flex-row">
              <div class="w-full mb-10 sm:mb-0 sm:w-full">
                <div class="relative h-full ml-0 mr-0 sm:mr-10">
                  <span class="absolute top-0 left-0 w-full h-full mt-1 ml-1 bg-blue-400 rounded-lg"></span>
                  <div class="relative h-full p-5 bg-white border-2 border-blue-400 rounded-lg">
                    <div class="flex items-center -mt-1">
                      <h3 class="my-2 ml-3 text-lg font-bold text-gray-800">
                        Frontend Services
                        <p class="text-xs font-medium text-blue-400 uppercase">
                          ------------
                        </p>
                      </h3>
                    </div>

                    <p class="mb-2 text-gray-600">
                      We specialize in crafting dynamic user interfaces using
                      JavaScript and React.js, with a focus on optimizing
                      efficiency and delivering seamless user experiences.
                    </p>
                  </div>
                </div>
              </div>
              <div class="w-full mb-10 sm:mb-0 sm:w-full">
                <div class="relative h-full ml-0 mr-0 sm:mr-10">
                  <span class="absolute top-0 left-0 w-full h-full mt-1 ml-1 bg-yellow-400 rounded-lg"></span>
                  <div class="relative h-full p-5 bg-white border-2 border-yellow-400 rounded-lg">
                    <div class="flex items-center -mt-1">
                      <h3 class="my-2 ml-3 text-lg font-bold text-gray-800">
                        Cloud Service
                        <p class="text-xs font-medium text-yellow-400 uppercase">
                          ------------
                        </p>
                      </h3>
                    </div>

                    <p class="mb-2 text-gray-600">
                      Working with AWS cloud, we optimize solutions for seamless
                      scalability and peak performance.
                    </p>
                  </div>
                </div>
              </div>
              <div class="w-full sm:w-full">
                <div class="relative h-full ml-0">
                  <span class="absolute top-0 left-0 w-full h-full mt-1 ml-1 bg-green-500 rounded-lg"></span>
                  <div class="relative h-full p-5 bg-white border-2 border-green-500 rounded-lg">
                    <div class="flex items-center -mt-1">
                      <h3 class="my-2 ml-3 text-lg font-bold text-gray-800">
                        Learning
                        <p class="text-xs font-medium text-green-500 uppercase">
                          ------------
                        </p>
                      </h3>
                    </div>

                    <p class="mb-2 text-gray-600">
                      In our ongoing pursuit of growth, we embrace learning new
                      skills daily to stay ahead of the curve and deliver
                      exceptional results.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
